export default __webpack_public_path__ + "static/media/tundra.0c1a51be.png";